export const ConfigQueryBuilderType ={
    '1' :'PRODUCTION',
    '2' : 'MANUAL_CALCULATION',
    '3' : 'OTHER'
}